import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import { Skeleton } from '@mui/material'
import AdxToolTip from 'components/custom/AdxToolTip'
import Icon from '@mui/material/Icon'

const AllocationList = ({
  type,
  expiryDate,
  amountBalance = 0,
  amountAllocation = 0,
  isLoading,
  isAsIncurred,
  cyclePeriod,
}) => {
  const claimFrequencyTooltip = cyclePeriod === 2 ? 'Monthly claim' : 'Annual claim'

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" justifyContent="space-between" alignItems="center" columnGap={3}>
        <Box>
          <Box
            position="relative"
            width={60}
            height={60}
            borderRadius="50%"
            bgcolor="alternate.light"
            sx={isAsIncurred ? { border: '2px dashed', borderColor: 'alternate.main' } : {}}
          >
            {!isLoading && !isAsIncurred && (
              <CircularProgress
                variant="determinate"
                color="alternate"
                value={(amountBalance / amountAllocation) * 100}
                size={60}
                thickness={2.5}
                sx={{ position: 'absolute' }}
              />
            )}
            <Box display="flex" justifyContent="center" alignItems="center" width={60} height={60}>
              {!isLoading && (
                isAsIncurred ? (
                  <Icon sx={{ color: 'alternate.main' }}>description</Icon>
                ) : (
                  <Typography variant="body1" sx={{ color: 'alternate.main' }}>
                    {Math.round((amountBalance / amountAllocation) * 100)}%
                  </Typography>
                )
              )}
            </Box>
          </Box>
        </Box>
        <Box>
          {isLoading ? (
            <Skeleton variant="text" width={250} sx={{ bgcolor: 'alternate.light' }} />
          ) : (
            <AdxToolTip
              title={type}
              placement="bottom-start"
              disableHoverListener={type.length < 19}
            >
              <Typography
                noWrap
                width={140}
                variant="body1"
                color="dark-text.main"
                textTransform="capitalize"
              >
                {type}
              </Typography>
            </AdxToolTip>
          )}

          {expiryDate && (
            <Typography variant="body2" color="light-gray-text.main">
              Expired on
              {` ${expiryDate}`}
            </Typography>
          )}
        </Box>
      </Box>
      {!isLoading && (
        <Box>
          {isAsIncurred ? (
            <Typography variant="body1" color="alternate.main" fontWeight="bold">
              As Incurred
            </Typography>
          ) : (
            <AdxToolTip title={claimFrequencyTooltip} placement="top" arrow>
              <Typography variant="body1" color="alternate.main" fontWeight="bold">
                {`RM ${amountBalance.toFixed(2)}`}
              </Typography>
            </AdxToolTip>
          )}
        </Box>
      )}
    </Box>
  )
}

export default AllocationList
